import React from 'react';
import ListingPreview from '../../../shared/templates/ListingTemplate/listing-preview';

export default function ProductPreview(props) {
  return (
    <ListingPreview {...props} section="store" />
  );
}